import { Deferred } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import PopularReviews from "components/books/PopularReviews";
import { PageSerializersBooksShow } from "types/serializers";
import LoadingBook from "hardcover-ui/components/LoadingBook";
import NetworkReviews from "./NetworkReviews";
import Suspense from "components/shared/Suspense";

export default function TopBookReviews({ book }: { book: PageSerializersBooksShow; }) {
  const isLoggedIn = useIsLoggedIn();
  const { reviews } = book;

  return (
    <Container variant="layout" size="md">
      <h2 className="sr-only">Reviews</h2>
      <div className="mt-4">
        <PopularReviews book={book} reviews={reviews} />

        {isLoggedIn ? (
          <Suspense fallback={<LoadingBook />}>
            <Deferred data="networkActivity" fallback={<LoadingBook />}>
              <NetworkReviews book={book} exclude={reviews} />
            </Deferred>
          </Suspense>
        ) : (
          <></>
        )}
      </div>
    </Container>
  );
}
